import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigurationService } from './services/configuration.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { AuthGuardService } from './services/authguard.service';
import { SecurityEndpoint } from './services/SecurityEndpoint.service';
import { SecurityService } from './services/security.service';
import { RegulatoryItemService } from './services/regulatoryitem.service';
import { RegulatoryItemEndpoint } from './services/regulatoryitemendpoint.service';
import { DepartmentService } from './services/department.service';
import { DepartmentEndpoint } from './services/departmentEndPoint.service';
import { UserAccessService } from './services/userAccess.service';
import { UserAccessEndpoint } from './services/userAccessEndpoint.service';
import { ReportService } from './services/report.service';
import { ReportEndpoint } from './services/reportendpoint.service';
import { EndpointFactory } from './services/endpoint-factory.service';
import { AlertService, MessageSeverity } from './services/alert.service';
import { PermitService } from './services/permit.service';
import { PermitEndpoint } from './services/permitendpoint.service';
import { DevExtremeModule, DxPopupModule, DxButtonModule, DxTemplateModule  } from 'devextreme-angular';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DevExtremeModule,
        DxTreeViewModule,
        DxPopupModule,
        DxButtonModule,
        DxTemplateModule 
    ],
    declarations: [
      
    ],
    exports: [
      DevExtremeModule,
      DxTreeViewModule,
      DxPopupModule,
      DxButtonModule,
      DxTemplateModule 
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
          ngModule: SharedModule,
            providers: [
              
            ]
        };
    }
}
